import React, { useCallback, useEffect, useRef, useState } from "react";
import CommonLayout from "../../../../Components/CommonLayout/CommonLayout.jsx";

import { useFetchAll } from "../../../../custom/FetchApiHook.jsx";
import BasicTable from "../../../../Components/CommonTable/BasicTable/BasicTable.jsx";
import {
  columns,
  searchBy,
} from "../../../../service/CancelationReasonService.js";
import { TemplateApi } from "../../../../App/api/setting.js";
import { useSelector } from "react-redux";
import AddCancellationReasonModal from "./CancellationReasonModal.jsx";
import { UsersApi } from "../../../../App/api/users.api.js";
import { DeleteModal } from "../../../../custom/modal/delteModal.jsx";

const CancellationReason = ({meta}) => {
  const [addTaxModle, setAddTextModal] = useState(false);
  const [deleteTaxModle, setDeleteTextModal] = useState(false);
  const [selected, setSelectedData] = useState(null);
  const [taxDataClicked, setTaxDataClicked] = useState(null);
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });

  const { value: allCancellationReason, fetchAllData } = useFetchAll(() =>
    TemplateApi.master.getAllCancellationReasons(pagination, search)
  );
  const { value } = useFetchAll(() => UsersApi.getUserRole());

  const taxData = [];
  const allTaxData = [];
  const allCancellationReasonData =
    allCancellationReason?.data?.cancellationReason;
  // console.log("allCancellationReason", allCancellationReasonData);

  // console.log("sort by ", searchBy);
  // console.log("value", value?.data);
  const { data: countryData } = useSelector((state) => state.country);

  const countryFilter = countryData?.map((item) => {
    return { name: item?.name, code: item?._id };
  });

  const filters = [
    {
      filterType: "By User Role",
      inputName: "order_type",
      options: value?.data,
    },
  ];

  const handleFilter = (name, value) => {
    // console.log("values inside handlefilter", value);
    if (value.code === "asc" || value.code === "desc") {
      setPagination((prev) => ({
        ...prev,
        sortOrder: value.code,
      }));
    } else {
      setPagination((prev) => ({
        ...prev,
        filter: { user_role: value?._id },
      }));
    }

    // console.log("e", value);
  };

  const handleSearch = useCallback((s) => {
    // console.log('Search at OrderCom', s);
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  console.log("Search ", search);
  useEffect(() => {
    fetchAllData();
  }, [pagination, search]);

  const handleCellClicked = (row, action) => {
    // console.log("action", action);
    if (action) {
      setAddTextModal(true);
      setTaxDataClicked(row);
    } else {
      setTaxDataClicked(row);
      setDeleteTextModal(true);
    }
  };
  const handleClearFilter = () => {
    setPagination({
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    });
  };
  const handlePagination = (data) => {
    // console.log(data);

    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }
    setPagination((prev) => {
      let copyfilter = { ...prev.filter };
      if (data.filter) {
        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(
            data.filter
          )[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }
      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };

  const onPaginatorClick = (e) => {
    if (e) {
      // console.log("Paginator Clicked", e);
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  return (
    <div className="p-5">
      <CommonLayout />
      <BasicTable
        data={allCancellationReasonData}
        // data={[]}
        // handleRowClick={handleRowclicked}
        handleClearFilter={handleClearFilter}
        handleSearch={debouncedSearch}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: allTaxData?.data?.page || 1,
          rows: allTaxData?.data?.limit || 5,
          // sortField: null,
          // sortOrder: null,
          totalPages: allTaxData?.data?.totalPages || 1,
          totalCount: allTaxData?.data?.totalCount || 1,
        }}
        selectedData={setSelectedData}
        columns={columns}
        handleFilter={handleFilter}
        handleCellClick={handleCellClicked}
        SearchBy={searchBy}
        filters={filters}
        WeekRange={false}
        // MonthRange={true}
        button_name="Add"
        handleButton={() => {
          setAddTextModal(true);
          setTaxDataClicked(null);
        }}
        // addItems={true}
      />
      <AddCancellationReasonModal
        isOpen={addTaxModle}
        onClose={() => setAddTextModal(false)}
        data={taxDataClicked}
        fetchAllData={fetchAllData}
        value={value}
      />

      <DeleteModal
        isOpen={deleteTaxModle}
        handleClose={() => setDeleteTextModal(false)}
        fetchAllData={fetchAllData}
        data={taxDataClicked}
        title="Delete Cancellation Reason"
        deleteApiFunction={TemplateApi.master.deleteCancellationReason}
        entityName="cancellation reason"
      />

      {/* <OrderComp pagination={pagination} handlePagination={handlePagination} /> */}
    </div>
  );
};

export default CancellationReason;
